class Intake {
    constructor(apiService = null) {
        this.obj_name = 'ack';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 送出前檢查表單填寫格式
    checkIntakeModel(formData) {
        const validations = [
            {
                condition:
                    formData.species_category_id === -1 || formData.species_id === -1,
                message: '請選擇物種類別與物種',
            },
            // {
            //     condition: formData.reporter_name === '',
            //     message: '請填寫通報人',
            // },
            // {
            //     condition: !formData.same_reporter_tag && formData.finder === '',
            //     message: '請填寫拾獲人，若同通報人請勾選通報人',
            // },
        ];

        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }

    // 受理單 | 101 搜尋受理單
    async acknowledgmentFormByKeywordWithPage(parameter = null) {
        return this.callApi('get', 'acknowledgmentFormByKeywordWithPage', parameter);
    }

    // 受理單 | 102 取得受理單詳細資料
    async getAcknowledgmentFormById(parameter) {
        return this.callApi('get', 'getAcknowledgmentFormById', parameter);
    }

    // 受理單 | 103 新增受理單
    async addAknowledgmentForm(parameter, progressEvent = null) {
        return this.callApi('post', 'addAknowledgmentForm', parameter, progressEvent);
    }

    // 受理單 | 104 更新受理單
    async updAknowledgmentForm(parameter, progressEvent = null) {
        return this.callApi('post', 'updAknowledgmentForm', parameter, progressEvent);
    }

    // 受理單 | 105 受理單綁定病例
    async updAknowledgmentFormMedicalId(parameter, progressEvent = null) {
        return this.callApi('post', 'updAknowledgmentFormMedicalId', parameter, progressEvent);
    }

    // 受理單 | 106 取得病例受理單列表
    async getAckCreateAndDischargeTimeByMedicalId(parameter) {
        return this.callApi('get', 'getAckCreateAndDischargeTimeByMedicalId', parameter);
    }

    //受理單 | 107匯入受理單
    async importAknowledgmentForm(parameter, progressEvent = null) {
        return this.callApi('post', 'importAknowledgmentForm', parameter, progressEvent);
    }
    //受理單｜108匯出受理單
    async exportAcknowledgmentFormByKeywordWithPage(parameter = null) {
        return this.callApi('get', 'exportAcknowledgmentFormByKeywordWithPage', parameter);
    }

}

export default Intake;
